import {createAction} from "@reduxjs/toolkit";
import axios from "axios";
import {showNotification, clearAll} from '@elements/alert-notification';
import {getConfigValue} from '@elements/config-utils';
import {translate} from '@elements/translations';

const configName = '_offers';

// Base Configuration Data Fetching
export const LIST_DATA_FETCH_ACTION_TYPE = 'list/fetch';
export const LIST_DATA_FETCHED_ACTION_TYPE = 'list/fetched';
export const LIST_DATA_FETCH_FAILED_ACTION_TYPE = 'list/fetch-failed';
export const ITEM_DISABLED_ACTION_TYPE = 'item/disabled';
export const ITEM_LOADING_START_ACTION_TYPE = 'item/loading-start';
export const ITEM_LOADING_END_ACTION_TYPE = 'item/loading-end';
export function requireData() {
    return function (dispatch, getState) {
        let state = getState();

        dispatch({
            type: LIST_DATA_FETCH_ACTION_TYPE
        });

        axios({
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            url: getConfigValue('baseUrl', configName),
            responseType: 'json'
        }).then(({data}) => {
            if (data.success) {
                dispatch({
                    type: LIST_DATA_FETCHED_ACTION_TYPE,
                    payload: data
                });
            }
        }).catch((error) => {
            dispatch({
                type: LIST_DATA_FETCH_FAILED_ACTION_TYPE
            });
        })
    }
}

// React on offer (accept/decline/change)
export function reactOffer(item, actionType, note = '', reason) {
    return function (dispatch, getState) {
        const baseUrl = getConfigValue('baseUrl', configName);
        const url = `${baseUrl}&action=${encodeURIComponent(actionType)}`;

        // Set loading state
        dispatch({
            type: ITEM_LOADING_START_ACTION_TYPE,
            payload: { itemId: item.id }
        });

        return axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url,
            data: {
                item,
                note,
                declineReason: reason
            },
            responseType: 'json'
        }).then(({data}) => {
            if (data && data.success) {
                showNotification({
                    type: 'light',
                    title: `<span class='icon icon-check text-success toast-header__icon'></span> ${data.message || translate('offers.reaction-success')}`,
                    closable: true
                });
                // set item disabled
                dispatch({
                    type: ITEM_DISABLED_ACTION_TYPE,
                    payload: { itemId: item.id, actionType: actionType }
                });
                //dispatch(requireData());
            } else {
                showNotification({
                    type: 'light',
                    title: `<span class='icon icon-close text-danger toast-header__icon'></span> ${(data && data.message) || translate('offers.reaction-failed')}`,
                    closable: true
                });
            }
            
            // Clear loading state
            dispatch({
                type: ITEM_LOADING_END_ACTION_TYPE,
                payload: { itemId: item.id }
            });
        }).catch((error) => {
            showNotification({
                type: 'light',
                title: `<span class='icon icon-close text-danger toast-header__icon'></span> ${translate('offers.reaction-failed')}: ${error}`,
                closable: true
            });
            
            // Clear loading state
            dispatch({
                type: ITEM_LOADING_END_ACTION_TYPE,
                payload: { itemId: item.id }
            });
        });
    }
}
